<template lang="pug">
section.signup.full__video.noBoxShadow
  .fluid__video.splash.form__video--horizontal
    iframe(data-src='https://media.flixel.com/cinemagraph/mv7tif44u6c1vm9e30cs' allow='autoplay')
  .fluid__video.splash.form__video--vertical
    iframe(data-src='https://media.flixel.com/cinemagraph/ab06d2jrwa3ppzhdym0h?hd=true' allow='autoplay')  
    .credit
      a(target='_blank' href='https://flixel.com/jimmycheung/') Jimmy Cheung
  .signup__form

    .message.success(v-show='forgotPasswordForm.success')
      p An e-mail has been sent to {{ userInfo.identifier }}
      a.close(@click='forgotPasswordForm.success = false')

    .message.error(v-show='forgotPasswordForm.error')
      p {{ forgotPasswordForm.error }}
      a.close(@click='forgotPasswordForm.error = false')
    form(
      name='forgotPasswordForm',
      v-on:submit.prevent='submitForgotPasswordInvoke(userInfo)')
      h1 Reset your password

      .ui-input
        p Username or Email
        input(
          type='text',
          v-model='userInfo.identifier',
          :disabled='forgotPasswordForm.success',
          placeholder='Your username or email',
          required)

      button.btn.btn--purpleLight(v-bind:class='emptyUserString' type='submit') Reset your password

      p
        router-link.link(to="/login/") Sign in here
</template>

<script>
import { _ } from 'vue-underscore';
import ForgotPasswordService from 'services/forgotpassword.es6.js';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      userInfo: {
        identifier: '',
      },
      forgotPasswordForm: {
        success: false,
        error: false,
      },
    };
  },
  computed: {
    emptyUserString() {
      return {
        invalid: this.userInfo.identifier.length === 0,
      };
    },
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  methods: {
    submitForgotPasswordSuccess() {
      this.forgotPasswordForm.success = true;
      this.forgotPasswordForm.error = false;
    },
    submitForgotPasswordError(data) {
      this.forgotPasswordForm.error = data.error;
    },
    readyForm(userInfo) {
      const isEmail = userInfo.identifier.indexOf('@') > 0;
      const key = isEmail ? 'email' : 'username';
      userInfo[key] = userInfo.identifier;
      return _.pick(userInfo, key);
    },
    submitForgotPasswordInvoke(userInfo) {
      const form = this.readyForm(userInfo);
      ForgotPasswordService.post(form)
        .then(this.submitForgotPasswordSuccess, this.submitForgotPasswordError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/auth/ForgotPassword.vue